import { withInstall } from "../utils/index.mjs";
import _Tabs from "./Tabs.mjs";
const Tabs = withInstall(_Tabs);
var stdin_default = Tabs;
import { tabsProps } from "./Tabs.mjs";
export {
  Tabs,
  stdin_default as default,
  tabsProps
};
